import React from 'react';
import { StatefulSelect } from '@components/StatefulInputs/StatefulSelect/StatefulSelect';
import { WebRequestFormValidatedState } from '@interfaces/RequestForm/forms/RequestFormValidatedState';
import { REQUIRED_DROPDOWN_NO_OPTION_SELECTED } from '@utilities/Validation/ValidationMessages';

const defaultOptions = [
	{ label: 'Inpatient', value: 'Inpatient' },
	{ label: 'Outpatient', value: 'Outpatient' },
	{ label: 'Observation / 23 hr', value: 'Observation / 23 hr' },
];

const RequestAuthStatusDropdown = () => {
	return (
		<StatefulSelect<WebRequestFormValidatedState>
			styleAsRequired={true}
			label="Intended order status/auth status"
			name="appointmentRequestAuthStatus"
			options={defaultOptions}
			placeholder="Select Status"
			controllerOptions={{
				rules: {
					required: REQUIRED_DROPDOWN_NO_OPTION_SELECTED
				}
			}}
			dataField="requestForm-requestAuthStatus-dropdown"
		/>
	);
};

export default RequestAuthStatusDropdown;
